import { z } from "zod";

/**
 * Trading platforms we support. Every prop firm is keyed to exactly one
 * platform_type; the Playwright bot uses this to pick a driver from its
 * registry, and the Worker uses it to route commands to the right adapter.
 */
export const PlatformTypeZ = z.enum([
  "mt4",
  "mt5",
  "dx-trade",
  "tradelocker",
  "ctrader",
  "match-trader",
  "tradovate",
  "ninjatrader",
  "blackarrow",
  "other",
]);
export type PlatformType = z.infer<typeof PlatformTypeZ>;

/**
 * Which side of the system executes trades for an account:
 *   - "ea":         desktop MT5/MT4 terminal running Exa_Hedge.mq5
 *   - "playwright": headless Chromium on the Pi running a platform driver
 */
export const AdapterTypeZ = z.enum(["ea", "playwright"]);
export type AdapterType = z.infer<typeof AdapterTypeZ>;
